import Badge from 'components/shared/Badge/Badge';
import Icon from 'components/shared/Icon/Icon';
import Switch from 'components/shared/Switch/Switch';
import Typography from 'components/shared/Typography/Typography';

const SwitchController = ({
  title,
  description,
  recommended,
  icon,
  checked,
  onChange,
  children
}) => {
  return (
    <div className="flex flex-col gap-3 rounded-md border border-solid border-neutral-200 bg-white px-3 py-2">
      <div className="flex h-fit min-h-[42px] items-center gap-2">
        {icon && <Icon icon={icon} size={20} />}
        <div className="flex flex-1 flex-col">
          <div className="flex items-center gap-2">
            <Typography variant="p" size="small" weight="medium" color="neutral-800">
              {title}
            </Typography>
            {recommended && <Badge text="Recommended" variant="lighter" color="primary" />}
          </div>
          {description && (
            <Typography variant="p" size="xs" color="neutral-800" className="block">
              {description}
            </Typography>
          )}
        </div>
        <Switch
          checked={checked}
          onChange={onChange}
          label={checked ? 'On' : 'Off'}
          parentContainerClassName="flex gap-2"
          labelClassName="font-normal pb-0"
        />
      </div>
      {checked && children && (
        <div className="border-0 border-t border-solid border-t-neutral-200 pt-3">{children}</div>
      )}
    </div>
  );
};

export default SwitchController;
